import { readCookie } from '@zapier/cookies';
import { useState, useEffect, useCallback } from 'react';

const queryPolicy = async (zapierUrl) => {
  const searchParams = new URLSearchParams();
  searchParams.append("limit", "1");
  searchParams.append("offset", "0");
  const url = `${zapierUrl}/api/v4/policies/agreements/pending/?${searchParams.toString()}`;
  const response = await fetch(url, {
    credentials: "include"
  });
  if (!response.ok) {
    throw new Error("Response was not OK");
  }
  const json = await response.json();
  const policy = json.results[0] || null;
  return policy;
};
const submitPolicyAcceptance = async (zapierUrl, slug, contentId) => {
  const response = await fetch(`${zapierUrl}/api/v4/policies/${encodeURIComponent(slug)}/agreements/`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": readCookie("csrftoken")
    },
    body: JSON.stringify({
      policy_content: contentId
    })
  });
  return response.ok;
};
const useQueryPolicyPending = (zapierUrl = "") => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [policy, setPolicy] = useState(null);
  useEffect(() => {
    queryPolicy(zapierUrl).then((p) => {
      setPolicy(p);
      setIsLoading(false);
    }).catch((_e) => {
      setIsLoading(false);
      setIsError(true);
    });
  }, [zapierUrl]);
  const acceptPolicy = useCallback(async () => {
    if (!policy)
      return false;
    const success = await submitPolicyAcceptance(zapierUrl, policy.slug, policy.content);
    setPolicy(null);
    return success;
  }, [policy, zapierUrl]);
  return {
    isLoading,
    isError,
    policy,
    acceptPolicy
  };
};

export { useQueryPolicyPending };
//# sourceMappingURL=useQueryPolicyPending.es.js.map
